import React from "react"
import styled from "styled-components"

import Card from "./Card"
import OverviewSimple from "./OverviewSimple"

const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  margin: 10px 0;
  box-shadow: var(--shadow-elavated);
`

const Image = styled.img`
  height: 100%;
`

type Props = {
  language: string
  flag: string
  proficiency: string
}

const LanguageTag = ({language, proficiency, flag}: Props) => 
  <StyledCard>
    <OverviewSimple
      graphic={<Image src={flag}/>}
      maintext={language}
      subtext={proficiency}
      />
  </StyledCard>

export default LanguageTag